import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp, Zap, Shield } from 'lucide-react';
import Button from '@/components/ui/Button';

const ClientsSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMyYjgyNWIiIHN0cm9rZS13aWR0aD0iMS41IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1vcGFjaXR5PSIwLjEiPjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjE1Ii8+PHBhdGggZD0iTTMwIDE1TDQ1IDMwIDMwIDQ1IDE1IDMweiIvPjwvZz48L3N2Zz4=')] opacity-30" />

      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <motion.h2 
              className="text-3xl md:text-4xl font-bold text-slate-900 mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              Les amis des <span className="text-orcsys-500">startups</span>
            </motion.h2>
            <motion.p 
              className="text-lg text-slate-600 max-w-3xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              Notre voulos aider les startups et les entrepreneurs early-stage à transformer 
              leurs idées en solutions technologiques performantes, tout en offrant un excellent 
              rapport qualité-prix.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {[
              {
                icon: <Star className="w-6 h-6 text-orcsys-500" />,
                title: "Qualité premium, prix accessible",
                description: "Nous offrons des services de qualité avec des tarifs abordables, grâce à notre structure optimisée."
              },
              {
                icon: <TrendingUp className="w-6 h-6 text-orcsys-500" />,
                title: "Croissance commune",
                description: "Nous investissons dans la réussite de nos clients. Votre croissance est notre priorité, et nous adaptons nos solutions à vos objectifs business."
              },
              {
                icon: <Zap className="w-6 h-6 text-orcsys-500" />,
                title: "Agilité et réactivité",
                description: "Notre équipe compacte nous permet d'être plus réactifs et flexibles que les grandes agences, tout en maintenant une qualité d'exécution élevée."
              },
              {
                icon: <Shield className="w-6 h-6 text-orcsys-500" />,
                title: "Expertise technique",
                description: "Bénéficiez de notre expérience en développement et de notre connaissance des besoins des startups."
              }
            ].map((feature, index) => (
              <motion.div
                key={index}
                className="bg-slate-50 rounded-xl p-6 shadow-lg border border-slate-100"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-lg bg-white shadow-md flex items-center justify-center flex-shrink-0">
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">{feature.title}</h3>
                    <p className="text-slate-600">{feature.description}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex flex-col sm:flex-row gap-4 items-center justify-center">
              <Button.Link 
                href="/contact"
                className="bg-orcsys-500 hover:bg-orcsys-600 text-white"
              >
                Discuter de votre projet
              </Button.Link>
              {/* <Button.Link 
                href="/portfolio"
                variant="outline"
                className="border-orcsys-200 text-orcsys-600 hover:bg-orcsys-50"
              >
                Découvrir nos réalisations
              </Button.Link> */}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection; 